module.exports = __webpack_public_path__ + "static/media/battery_levels_widget.1867d718.png";